import ReactTooltip from 'react-tooltip';

const HelperComponent = ({href, component}) => {

    const onHelperClick = () => {
        window.open(href, '_blank');
    }

    

    return <>
    <i 
        data-tip={`View ${component}'s documentation`}
        onClick={onHelperClick} 
        className="icon icon-help ml-2"
    >    
    </i>
    <ReactTooltip />
    </>
}

export default HelperComponent;